module.exports = __webpack_public_path__ + "static/media/earth.7a6341f5.svg";